export const getRandomAriaId = () => `aria-${Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1)}`;
export const hexToRGB = (hex, alpha) => {
    if (!hex || [4, 7].indexOf(hex.length) === -1) {
        return 'Invalid Hex Code';
    }
    // if shortcuts (#F00) -> set to normal (#FF0000)
    let hexValue = hex.substring(1);
    if (hexValue.length === 3) {
        hexValue = hexValue
            .split('')
            .map((el) => el + el)
            .join('');
    }
    const r = parseInt(hexValue.slice(0, 2), 16);
    const g = parseInt(hexValue.slice(2, 4), 16);
    const b = parseInt(hexValue.slice(4, 6), 16);
    if (alpha) {
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    return `rgb(${r}, ${g}, ${b})`;
};
